import React, { useState, useEffect } from "react";
import CreateProductBtn from "../../../components/CreateProductBtn";
import FStatsCards from "./FStatsCards";
import FFilters from "./FFilters";
import FBookingCardsList from "./FBookingCardsList";
import { useGetFinanceListingQuery } from "../../../rtk-query/slices/finance/financeSlice";
import { buildQueryString } from "../../../helpers/buildQueryString";
import { Pagination } from "../../../components/Pagination";
import { ShimmerContentBlock } from "react-shimmer-effects";
import { useSearchParams } from "react-router-dom";
function FinanceMainWrapper() {
  // State for the filters
  const [searchParams, setSearchParams] = useSearchParams();
  const [searchVoucherId, setSearchVoucherId] = useState("");
  const [searchProductTitle, setSearchProductTitle] = useState("");
  const [date, setDate] = useState(
    searchParams.get("date") ? new Date(searchParams.get("date")) : null
  );
  const [selectedFilter, setSelectedFilter] = useState("all");
  const [selectedQuickFilter, setSelectedQuickFilter] = useState(
    searchParams.get("quickFilters")
      ? searchParams.get("quickFilters").split(",")
      : []
  );
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10); // For example, 10 items per page

  const quickFilters = [
    { label: "Today", value: "today", count: 5 },
    { label: "Tomorrow", value: "tomorrow", count: 12 },
    { label: "Next 5 Days", value: "next_5_days", count: 13 },
    { label: "Next 7 Days", value: "next_7_days", count: 13 },
    { label: "Completed", value: "completed", count: -1 },
    { label: "Pending", value: "pending", count: -1 },
    { label: "Expired", value: "expired", count: -1 },
  ];

  // Destructure the data from the API query
  const {
    data: orderLisitings,
    isLoading,
    isFetching,
    status,
    isError,
    refetch,
  } = useGetFinanceListingQuery(
    buildQueryString({
      voucher_number: searchVoucherId,
      trip_date: date instanceof Date ? date.toISOString().split("T")[0] : "",
      product_title: searchProductTitle,
      trip_date_filter: selectedQuickFilter,
      status_filter: selectedFilter,
      page: currentPage,
      limit: pageSize, // Assuming the backend supports `page` and `limit` parameters
    })
  );

  console.log("API Status:", isLoading, isFetching, status);

  // Effect to refetch when any filter state changes
  useEffect(() => {
    // Refetch the data whenever the filters change
    refetch();
  }, [searchVoucherId, date, selectedFilter, searchProductTitle]);

  const clearFilters = () => {
    // Reset filters to default values and refetch data
    setSearchVoucherId("");
    setDate(null);
    setSelectedFilter("all");
    setSearchProductTitle("");
    setSelectedQuickFilter([]);
  };

  const totalBookings = orderLisitings?.data?.orders?.total || 0;
  const totalPages = Math.ceil(totalBookings / pageSize);

  useEffect(() => {
    if (currentPage > orderLisitings?.data?.orders?.last_page) {
      setCurrentPage(orderLisitings?.data?.orders?.last_page);
    }
  }, [orderLisitings]);

  return (
    <div className="dod-product-listing-main-wrapper">
      {/* title and create product button */}
      <div className="w-100 d-flex align-items-center justify-content-between">
        <h2 className="ob-supplier-content-heading">Bookings</h2>
      </div>

      {/* all sections */}
      <FStatsCards
        totalSales={orderLisitings?.data?.totalSales}
        redeemedAmount={orderLisitings?.data?.RedeemedAmount}
        expiredVouchers={orderLisitings?.data?.ExpiredVoucher}
      />

      {/* Pass down filter states and handlers */}
      <FFilters
        date={date}
        setDate={setDate}
        selectedFilter={selectedFilter}
        setSelectedFilter={setSelectedFilter}
        quickFilters={quickFilters}
        clearFilters={clearFilters}
        setSearchProductTitle={setSearchProductTitle}
        searchProductTitle={searchProductTitle}
        selectedQuickFilter={selectedQuickFilter}
        setSelectedQuickFilter={setSelectedQuickFilter}
      />

      {/* Booking List */}
      {isLoading ||
        (isFetching ? (
          <ShimmerContentBlock
            title
            text
            cta
            thumbnailWidth={370}
            thumbnailHeight={370}
          />
        ) : (
          <FBookingCardsList
            bookings={orderLisitings?.data?.orders?.data}
            searchVoucherId={searchVoucherId}
            setSearchVoucherId={setSearchVoucherId}
          />
        ))}

      {/* Pagination */}
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={(page) => setCurrentPage(page)}
      />
    </div>
  );
}

export default FinanceMainWrapper;
